import { EuiStepsHorizontal } from "@inscopix/ideas-eui";
import { useToolEditorContext } from "components/ToolEditor/Provider/ToolEditorProvider";
import { useToolEditorTimelineStatus } from "../../Provider/store/hooks/useToolEditorTimelineStatus";
import {
  TOOL_EDITOR_PAGES,
  ToolEditorPageKey,
} from "components/ToolEditor/Provider/store/ToolEditorProvider.store";

interface ToolEditorTimelineProps {
  page: ToolEditorPageKey;
}

export const ToolEditorTimeline = ({ page }: ToolEditorTimelineProps) => {
  const timelineStatusByPage = useToolEditorTimelineStatus(page);
  const onClickTimelinePage = useToolEditorContext(
    (s) => s.onClickTimelinePage,
  );

  return (
    <EuiStepsHorizontal
      steps={TOOL_EDITOR_PAGES.map((page) => {
        const { status, isDisabled } = timelineStatusByPage[page.key];
        return {
          key: page.key,
          title: page.title,
          status: status,
          disabled: isDisabled,
          onClick: () => {
            // disabled status overrides loading visually so we can use this to disable handler for loading states
            if (status !== "loading") {
              onClickTimelinePage(page.key);
            }
          },
        };
      })}
    />
  );
};
